import { render, staticRenderFns } from "./offline_aftersale_list.vue?vue&type=template&id=54cc8f6e&scoped=true"
import script from "./offline_aftersale_list.vue?vue&type=script&lang=js"
export * from "./offline_aftersale_list.vue?vue&type=script&lang=js"
import style0 from "./offline_aftersale_list.vue?vue&type=style&index=0&id=54cc8f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cc8f6e",
  null
  
)

export default component.exports